<template>
  <basic-container style="overflow: hidden">
    <div class="accountManagement">
      <div class="content_box">
        <div class="search_box">
          <div style="">
            <div class="layui-row layui-col-space30" v-html="baseInfoData">

            </div>
            <el-form :inline="true" :model="formData" class="demo-form-inline" size="mini">
              <el-form-item label="员工姓名">
                <el-input v-model="formData.name" type="primary" style="width: 120px" placeholder="请输入员工姓名"></el-input>
              </el-form-item>
              <el-form-item label="主叫号码">
                <el-input v-model="formData.calleeNum" type="primary" placeholder="请输入主叫号码"></el-input>
              </el-form-item>
              <el-form-item label="被叫号码">
                <el-input v-model="formData.fwdDstNum" type="primary" placeholder="请输入被叫号码"></el-input>
              </el-form-item>
              <!--                        <el-form-item label="合同号范围">-->
              <!--                            <el-input v-model="formData.contractSortQ" placeholder="合同号起" style="width: 45%"></el-input>- -->
              <!--                            <el-input v-model="formData.contractSortZ" placeholder="合同号止" style="width: 45%"></el-input>-->
              <!--                        </el-form-item>-->
              <el-form-item label="呼叫时间">
                <el-date-picker v-model="formData.date" type="datetimerange"  style="width: 360px"  :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" align="right"></el-date-picker>
              </el-form-item>
              <el-form-item label="通话时长至少">
                <el-input v-model="formData.billsec" type="primary" style="width: 120px" placeholder="请输入">
                  <template slot="append">秒</template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSearch" icon="el-icon-search">查询</el-button>
                <el-button plain @click="reset"><i class="iconfont icon-k-i-rese"></i>重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="productContent" style="height: 100%;overflow: auto">
          <table class="layui-table myTable">
            <thead>
              <tr>
                <td>员工姓名</td>
                <td>主叫号码</td>
                <td>被叫号码</td>
                <td>通话时间</td>
                <td>通话时长</td>
                <td>通话录音</td>
                <td>失败原因</td>
              </tr>
            </thead>
            <tbody v-html="tableData">

            </tbody>
          </table>
        </div>
        <div class="pageBox" style="text-align: right;padding-top: 5px">
          <table-page :pagination="pagination" @change="pageChange"></table-page>
        </div>
      </div>
    </div>
  </basic-container>
</template>

<script>
    import TablePage from "../../components/TablePage";
    import {getList,getCallRecordFile,getBaseInfo} from '@/api/customer/recordPhone';
    export default {
        name: "recordPhone",
        components: {
          TablePage,
        },
        data() {
          return {
            pickerOptions: {
              shortcuts: [{
                text: '最近一周',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近一个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近三个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                  picker.$emit('pick', [start, end]);
                }
              }]
            },
            formData: {
              name:'',
              calleeNum:'',
              fwdDstNum:'',
              date:[],
              billsec:'',
            },
            tableData:'',
            baseInfoData:'',
            pagination: {
              currentPage: 1,
              pageSize: 20,
              total: 0,
            },
          }
        },
        methods: {
            pageChange() {
              this.getList(this.pagination)
            },
            onSearch(){
              this.getList(this.pagination)
            },
            reset(){
                this.formData = {
                    name:'',
                    calleeNum:'',
                    fwdDstNum:'',
                    date:[],
                    billsec:'',
                }
            },
            getBaseInfoData(){
              getBaseInfo().then(res => {
                const data = res.data.data
                this.baseInfoData = data.replaceAll("<div class=\"layui-col-md3\">","<div class=\"layui-col-md4\">");
                this.baseInfoData = this.baseInfoData.replaceAll("http://bqihui.xiaoshengqifu.com/image/lock.png","/img/lock.png");
                this.baseInfoData = this.baseInfoData.replaceAll("http://bqihui.xiaoshengqifu.com/image/money.png","/img/money.png");
                this.baseInfoData = this.baseInfoData.replaceAll("http://bqihui.xiaoshengqifu.com/image/listen.png","/img/listen.png");
                this.baseInfoData = this.baseInfoData.replaceAll("<a href=\"http://bqihui.xiaoshengqifu.com/bound/pay\" class=\"online\">在线充值</a>","");
                this.baseInfoData = this.baseInfoData.replaceAll("<span class=\"recharge\">充值记录</span>","");
                this.baseInfoData = this.baseInfoData.replaceAll("<span class=\"payRecord\">外呼统计</span>","<span class=\"payRecord\" onclick='clickBtn()'>外呼统计</span>");
                this.baseInfoData = this.baseInfoData.split("<div class=\"layui-col-md3 call-record\" >")[0]
                console.log('555');
                console.log(data);
              });
            },
            getList(page) {
              let Obj = Object.assign({},this.formData);
              if (Obj.date && Obj.date.length>1){
                Obj.date = Obj.date[0] + ' - ' + Obj.date[1]
              }
              getList(page.currentPage, page.pageSize, Object.assign({}, Obj)).then(res => {

                const data = JSON.parse(res.data.data)
                // console.log(data.html);
                this.tableData = data.html.replaceAll("<a href=\"http://bqihui.xiaoshengqifu.com/records/down/","<el-button style='color:#01aaed;cursor:pointer;' onclick=\"skipBtn(");
                this.tableData = this.tableData.replaceAll("\" target=\"_blank\">下载</a>",")\">下载</el-button>");
                this.pagination.total = Number(data.count);
                // console.log(this.tableData);
              });
            },
            clickBtn(){
              this.$router.push('/recordStatistics')
            },
            skipBtn(id){
              getCallRecordFile(id).then(res => {
                if(res.data.code == '200'){
                  window.open(res.data.data,'_blank')
                }
                // window.location.href = res.data.data
              });
            }
        },
        mounted() {
            window.skipBtn = this.skipBtn;
            window.clickBtn = this.clickBtn;
            let a = new Date(),
              year = a.getFullYear(),
              month = a.getMonth()+1 < 10 ? "0"+(a.getMonth()+1) : a.getMonth()+1,
              date = a.getDate() < 10 ? "0"+a.getDate() : a.getDate();
            let start = "" + year + "-" + month + "-" + date + " 00:00:00",last = "" + year + "-" + month + "-" + date + " 23:59:59";
            this.formData.date = [start,last]
            this.getList(this.pagination);
            this.getBaseInfoData()
        }
    }
</script>

<style scoped lang="scss">
  @import'/cdn/xiaosheng/layui.css';
  @import'/cdn/xiaosheng/common.css';
  @import'/cdn/xiaosheng/xiaosheng.css';
  @import'/cdn/xiaosheng/bound-open.css';
  .accountManagement {
    height: calc(100%);
    padding-bottom: 10px !important;
    .content_box {
      display: flex;
      flex-direction: column;
      background: #fff;
      width: auto;
      height: 100%;
      border-radius: 4px;
      box-sizing: border-box;
      padding: 15px;
      padding-top: 0;
      .search_box {
        margin-bottom: 20px;
      }
      .productContent {
        flex: 1;
        height: 100px;
      }
    }
  }
  .layui-row{
    margin-top: 0;
  }
  .layui-col-space30>* {
    padding: 0 15px 20px;
  }
  td{
    color: #fff;
    background: #40a9ff !important;
  }

</style>
